import React, { useState, useEffect, useMemo } from 'react';
import { View } from 'react-native'

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import api from '@/utils/api';



import { useQuery } from '@tanstack/react-query';
import Select from '@/components/Forms/Select';
import { useController } from 'react-hook-form';




//! TODO: usar un combobox https://ui.shadcn.com/docs/components/combobox

export default function VinteExpenseTypeSelector({ control, setValue, name, value, rules }) {
  const { isLoading, error, data: expenseTypes } = useQuery({
    queryKey: ['vinte.expenses-types'],
    queryFn: () => api.get(`/vinte/expense-types`).then(response => response.data),
  })

  const { field, fieldState: { invalid, isTouched, isDirty } } = useController({
    control: control,
    defaultValue: value,
    name: name,
    rules: rules,
  })

  // const options = useMemo(() => {
  //   const defaultValue = { value: "", label: "Sin definir" }

  //   const options = paymentMethods?.map(method => {
  //     return { value: method.uuid, label: method.name, key: method.uuid }
  //   })

  //   return options ? [...options] : []
  // }, [paymentMethods])

  

  return (
    <View style={tw``}>

        <select
          onChange={ev => field.onChange(ev.target.value)}
          // name={name}
          // placeholder={{ value: "", label: "Sin definir" }}
          // items={options}
          // rules={{ required: true }}
          style={tw.style(`px-4 py-3 rounded-xl border border-gray-400`)}
        >
          {/* !DISABLED dinamico */}
          {
            isLoading ?
              <option disabled={false} value={""}>Cargando...</option>
            :
              <option disabled={false} value={""}>Elegir Tipo de Gasto</option>
          }

          {
            expenseTypes?.map(parent => 
              <optgroup key={parent.uuid} label={parent.name}>
                {
                  parent.children.map(child => 
                    <option key={child.uuid} value={child.uuid}>{child.name}</option>
                  )
                }
              </optgroup>
            )
          }
        </select>

       {
          !!error?.message && <Text style={{ marginTop: 10, color: tw.color('red-400') }}>{error.message}</Text>
        }
    </View>
  )
}